import React from 'react';

export default function LoadingSpinner({ size = 'md', text = '' }) {
  const sizeClass = size === 'sm' ? 'w-5 h-5' : size === 'lg' ? 'w-10 h-10' : 'w-8 h-8';
  return (
    <div className="flex flex-col items-center justify-center gap-3" data-testid="loading-spinner">
      <div
        className={`${sizeClass} border-3 border-gray-200 border-t-[#5BA4CF] rounded-full animate-spin`}
        style={{ borderWidth: '3px' }}
      />
      {text && <p className="text-sm text-gray-500">{text}</p>}
    </div>
  );
}
